import { StyleRules, Theme } from '@material-ui/core';

export default (theme: Theme): StyleRules => ({
  authError: {
    color: '#D92E4D',
    marginTop: '-35px',
    position: 'absolute',
  },
  errorText: {
    '& .MuiFormHelperText-root': {
      marginTop: '30px',
    },
    '& label.Mui-focused': {
      color: '#D92E4D',
    },
  },
  formControl: {
    margin: '45px 0',
    width: '100%',
  },
  textField: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderLeft: 0,
      borderRight: 0,
      borderTop: 0,
    },
    '& .MuiOutlinedInput-root': {
      minHeight: '64px',
    },
    backgroundColor: 'white',
    borderRadius: 10,
    height: '64px',
    margin: '5px 0',
  },
});
